import React, { useContext, useState } from 'react'

const DriverAssignmentConfirm = ({ vehReqContext, reqVehicleClass }) => {
  const context = useContext(vehReqContext);
  const [vehicles,] = useState(context[reqVehicleClass]?.driverAssignment?.vehicles); //driverList

  return (
    <>
      {/* Ask about margin bottom */}
      <div className='col-12 mt-5 mb-4' style={{ fontSize: '16px' }}>
        {/* Ask about margin bottom */}
        <h5 className='text-primary text-center fw-bold mb-3'>DRIVER ASSIGNMENT</h5>

        <div className='row'>
          {vehicles.map((vehicle, vehicleIndex) => {
            return (
              // (driver?.driverStatus == "" || driver?.driverStatus == "New Driver" || driver?.driverStatus == "Adding As Driver") && //Add if needed
              <div className='row pb-2' key={vehicleIndex}>
                <div className='col-xs-12 col-md-8'>
                  <strong className="text-primary">
                    {"vehicleVIN" in vehicle ?
                      <span className="text-uppercase">{vehicle.vehicleYear} {vehicle.vehicleMake} {vehicle.vehicleModel} - {vehicle.vehicleVIN}</span>
                      :
                      <span className="text-uppercase">{vehicle.Year} {vehicle.Make} {vehicle.Model} - {vehicle.VIN}</span>
                    }
                  </strong>
                </div>
                <div className='col-xs-12 col-md-4'>
                  <span className="text-uppercase">{vehicle.driverName}</span>
                  <span>{"vehicleType" in vehicle ? " - " + vehicle?.vehicleType : ""}</span>
                  <br /><br />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default DriverAssignmentConfirm